import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ProductModel } from '../../../models/master-data/products.model';
import { ProductsService } from './products.service';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { MdDialogRef, MD_DIALOG_DATA, MdOption } from '@angular/material';
import { AppMessages } from '../../../shared/constants/messages';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { CurrencyNumberDirective } from '../../../directives/currency-number.directive';
import { CurrencyNumberPipe } from '../../../pipes/currency-number.pipe';
import { ManagePriceListService } from '../../centre/manage-price/manage-price-list.service';
import { AppConstants } from '../../../shared/constants/constants';

@Component({
    selector: 'update-product-popup',
    templateUrl: 'update-product-popup.component.html',
    providers: [ProductsService, ManagePriceListService, CurrencyNumberPipe, CurrencyNumberDirective]
})

export class UpdateProductPopupComponent implements OnInit {
    productForm: FormGroup;
    productModel = new ProductModel();
    formMessage = '';
    vaccines: any;
    productCategories: any;
    suppliers: any;
    public title: string;
    public isSuccess = false;
    public currencyObj = {
        code: '',
        id: '',
        symbol: '',
        symbolPosition: 'L',
        rate: 1
    };
    centres = JSON.parse(localStorage.getItem(AppConstants.localStorage.centres));
    currentCentreId = localStorage.getItem(AppConstants.localStorage.centreId);
    selectAll = {centreId: '00000000-0000-0000-0000-000000000000', centreName: 'Apply to all'}
    @ViewChild('allSelected') public allSelected: MdOption;
    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public dialogService: DialogService,
        public utility: Utility,
        private productsService: ProductsService,
        public dialogRef: MdDialogRef<UpdateProductPopupComponent>,
        @Inject(MD_DIALOG_DATA) public data: any
    ) {
        this.createForm();
    }

    ngOnInit() {
      this.productsService.getProductCategoryList().subscribe(
        result => {
            if (result) {
                const dataCategory = result.json();
                this.productCategories = dataCategory['list'];
            }
        }
      );

      this.productsService.getSuppliersList().subscribe(
          (result) => {
              if (result) {
                  const dataSupplier = result.json();
                  this.suppliers = dataSupplier['list'];

              }
          }
      );

      this.currencyObj = this.data.listCurencies.find(c => c.code === this.data.currencyCode);

      if (this.data.id) {
        this.title = 'Update Product';
        this.productsService.getProductById(this.data.id).subscribe(
          (result) => {
              if (result) {
                  let dataProduct = result.json();
                  this.productForm.get('costPrice').setValue(dataProduct.costPrice);
                  this.productForm.get('defaultPrice').setValue(dataProduct.defaultPrice);
                  this.productModel = this.productModel.setModel(dataProduct);
                  this.productModel.centreIds = [this.currentCentreId];
              }
          }, error => {
          }
        );

      } else {
          this.title = 'Add New Product';
          this.productForm.controls['productCategoryId'].setValue(this.data.categoryId);
          this.productModel.productCategoryId = this.data.categoryId;
          this.productModel.centreIds = [this.currentCentreId];
      }
    }

    createForm() {
        this.productForm = this.formBuilder.group({
            name: ['', [Validators.required]],
            productCategoryId: ['', [Validators.required]],
            supplierId: ['', [Validators.required]],
            costPrice: ['', [Validators.required, this.isValidCurrencyRange]],
            defaultPrice: ['', [Validators.required, this.isValidCurrencyRange]],
            description: [''],
            centreIds: ['', [Validators.required]],
            productId: ['']
        });
    }

    tosslePerOne() {
      if (this.allSelected.selected) {
        this.allSelected.deselect();
        let updatedValues = this.productForm.controls.centreIds.value.filter(value => value !== this.selectAll.centreId);
        this.productForm.controls.centreIds.setValue(updatedValues);
        return false;
      }
      if (this.productForm.controls.centreIds.value.length == this.centres.length)
      {
        this.allSelected.select();
        let currentValues = this.productForm.controls.centreIds.value;
        let updatedValues = [...currentValues, this.selectAll.centreId];
        this.productForm.controls.centreIds.setValue(updatedValues);
      }
    }
    toggleAllSelection() {
      if (this.allSelected.selected) {
          this.productForm.controls.centreIds.patchValue([...this.centres.map(item => item.centreId), this.selectAll.centreId]);
        } else {
            this.productForm.controls.centreIds.patchValue([]);
        }
    }


    isValidCurrencyRange(control: AbstractControl) {
      if (+control.value < 0 || +control.value > 10000) {
        return { 'invalidDecimalRange/0/10000': true };
      }
      return null;
    }

    roundPriceNumber(num) {
      return Math.round(num * 100) / 100;
    }
    onSubmit() {
      if (this.productForm.valid) {
        // Edit product if product id exist, if not add product
        if (this.productModel.id) {
          this.productsService.updateProduct(this.data.id, this.productForm.value).subscribe(
            (result) => {
              if (result) {
                  const data = result.json();
                  this.dialogService.openSuccessDialog({ message: data.message });
                  this.isSuccess = true;
                  this.close();
              }
            }
          );
        } else {
          this.productsService.addNewProduct(this.productForm.value).subscribe(
              result=>{
                  if(result){
                      const data = result.json();
                      this.dialogService.openSuccessDialog({message : data.message});
                      this.isSuccess = true;
                      this.close();
                  }
              }
          );
        }
      }
    }

    close() {
        this.dialogRef.close(this.isSuccess);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/products/update-product-popup.component.ts